// ============================================================
// PREZENCE — Topbar
// ============================================================
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../api/client';

export default function Topbar({ title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [showNotif, setShowNotif] = useState(false);
  const unread = notifications.filter(n => !n.is_read).length;

  useEffect(() => {
    api.get('/notifications').then(r => setNotifications(r.data.data || [])).catch(() => {});
  }, []);

  const markAllRead = async () => {
    await api.patch('/notifications/read-all').catch(() => {});
    setNotifications(prev => prev.map(n => ({ ...n, is_read: true })));
  };

  const profilePath = `/${user?.role === 'admin' || user?.role === 'superadmin' ? 'admin' : user?.role}/profile`;

  return (
    <header style={{
      height: 60,
      background: 'rgba(8,12,20,0.97)',
      borderBottom: '1px solid rgba(56,189,248,0.07)',
      display: 'flex',
      alignItems: 'center',
      padding: '0 28px',
      gap: 16,
      flexShrink: 0,
      backdropFilter: 'blur(10px)',
      position: 'relative',
      zIndex: 9,
    }}>
      {/* Page title */}
      <div style={{ flex: 1 }}>
        <h1 style={{ fontSize: 16, fontWeight: 800, color: '#f0f6ff', fontFamily: "'DM Sans',sans-serif" }}>{title}</h1>
      </div>

      {/* Live indicator */}
      <div style={{ display:'flex', alignItems:'center', gap:6, background:'rgba(34,197,94,0.08)', border:'1px solid rgba(34,197,94,0.2)', borderRadius:20, padding:'5px 12px' }}>
        <div style={{ width:6, height:6, borderRadius:'50%', background:'#22c55e', animation:'pulse-dot 1.5s infinite' }} />
        <span style={{ fontSize:11, color:'#22c55e', fontFamily:"'JetBrains Mono'", fontWeight:600 }}>LIVE</span>
      </div>

      {/* Notifications */}
      <div style={{ position:'relative' }}>
        <button onClick={() => setShowNotif(s => !s)} style={{
          background: showNotif ? 'rgba(56,189,248,0.1)' : 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.08)',
          color: '#94a3b8', borderRadius: 10,
          width: 36, height: 36, cursor:'pointer',
          display:'flex', alignItems:'center', justifyContent:'center',
          position: 'relative', fontSize: 16,
          transition: 'all 0.2s',
        }}>
          🔔
          {unread > 0 && (
            <span style={{
              position:'absolute', top:-4, right:-4,
              width:16, height:16, borderRadius:'50%',
              background:'#ef4444', color:'#fff',
              fontSize:9, fontWeight:700,
              display:'flex', alignItems:'center', justifyContent:'center',
              fontFamily:"'JetBrains Mono'",
            }}>{unread}</span>
          )}
        </button>

        {showNotif && (
          <div style={{
            position:'absolute', top:42, right:0,
            width:320, background:'#0d1520',
            border:'1px solid rgba(56,189,248,0.15)',
            borderRadius:14, boxShadow:'0 20px 60px rgba(0,0,0,0.5)',
            overflow:'hidden', zIndex:100,
            animation:'fadeIn 0.2s ease',
          }}>
            <div style={{ padding:'14px 16px', borderBottom:'1px solid rgba(56,189,248,0.08)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span style={{ fontSize:12, fontWeight:700, color:'#94a3b8', fontFamily:"'JetBrains Mono'", letterSpacing:'0.08em' }}>NOTIFICATIONS</span>
              {unread > 0 && <button onClick={markAllRead} style={{ fontSize:11, color:'#63dcbc', background:'none', border:'none', cursor:'pointer' }}>Mark all read</button>}
            </div>
            <div style={{ maxHeight:300, overflowY:'auto' }}>
              {notifications.length === 0 ? (
                <div style={{ padding:'24px', textAlign:'center', color:'#475569', fontSize:13 }}>No notifications</div>
              ) : notifications.map(n => (
                <div key={n.id} style={{
                  padding:'12px 16px',
                  borderBottom:'1px solid rgba(56,189,248,0.04)',
                  background: n.is_read ? 'transparent' : 'rgba(99,220,188,0.03)',
                }}>
                  <div style={{ fontSize:13, color: n.is_read ? '#64748b' : '#e2e8f0', fontWeight: n.is_read ? 400 : 600, marginBottom:3 }}>{n.title}</div>
                  {n.message && <div style={{ fontSize:11, color:'#475569' }}>{n.message}</div>}
                  <div style={{ fontSize:10, color:'#334155', marginTop:4, fontFamily:"'JetBrains Mono'" }}>
                    {new Date(n.created_at).toLocaleString('en-IN', { day:'numeric', month:'short', hour:'2-digit', minute:'2-digit' })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Avatar → profile */}
      <button onClick={() => navigate(profilePath)} style={{
        background: 'linear-gradient(135deg,#63dcbc,#3ba8ff)',
        border:'none', borderRadius:10,
        width:34, height:34, cursor:'pointer',
        fontSize:13, fontWeight:800, color:'#05090f',
        display:'flex', alignItems:'center', justifyContent:'center',
        flexShrink:0,
      }}>
        {(user?.full_name || 'U').split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase()}
      </button>

      {/* Logout */}
      <button onClick={logout} title="Logout" style={{
        background:'rgba(239,68,68,0.08)', border:'1px solid rgba(239,68,68,0.2)',
        color:'#ef4444', borderRadius:10, padding:'0 12px', height:34,
        cursor:'pointer', fontSize:12, fontWeight:600, fontFamily:"'DM Sans',sans-serif",
      }}>Logout</button>
    </header>
  );
}
